/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import Grid from "@material-ui/core/Grid";
import { Divider, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MatButton from "@material-ui/core/Button";

//custom library
import { Button, TextArea } from "../components";
import addressHelper from "../helpers/addressHelper";

export default function AddOrderComment(props: any) {
  const [showCommentField, setShowCommentField] = React.useState(false);
  const { t } = useTranslation();
  const { saveChange, orderHandleChange, cancelChange, inputComment } = props;

  return (
    <>
      <Grid
        item
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={2}>
        <Grid item>
          <Typography variant="h2">{t("OrderManagement.Comments")}</Typography>
        </Grid>
        <Grid item>
          <Button
            color="secondary"
            size="small"
            onClick={() => {
              setShowCommentField(true);
            }}>
            {t("OrderManagement.AddComment")}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      {showCommentField && (
        <Grid
          item
          container
          direction="column"
          spacing={2}
          justify="flex-start"
          alignItems="flex-start"
          style={{ backgroundColor: "#efefef" }}>
          <Grid item container direction="row" xs={12}>
            <Typography variant="h3" style={{ margin: 8 }}>
              {t("OrderManagement.AddComment")}
            </Typography>
          </Grid>
          <Grid item container direction="row">
            <TextArea
              style={{ backgroundColor: "white" }}
              placeholder="order comment"
              multiline
              rowsMax={4}
              fullWidth
              variant="Filled"
              value={inputComment}
              onChange={(e: any) => orderHandleChange(e)}
              inputProps={{
                maxLength: 3000,
              }}
            />
          </Grid>
          <Grid
            item
            container
            spacing={2}
            justify="flex-start"
            alignItems="flex-start">
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                style={{ margin: 8 }}
                disabled={addressHelper.canSave(inputComment)}
                onClick={() => {
                  saveChange().then(() => setShowCommentField(false));
                }}>
                {t("OrderManagement.Save")}
              </Button>
            </Grid>
            <Grid item>
              <MatButton
                size="medium"
                color="primary"
                style={{ margin: 8 }}
                onClick={() => {
                  cancelChange();
                  setShowCommentField(false);
                }}>
                {t("Table.Actions.Cancel")}
              </MatButton>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
